import React, { useState } from "react";
import "../assets/Styles/contact.css";
import "../assets/Styles/Allfonts.css";
import Alerts from "./Alerts";
import { submitCustomerQuery } from "../reducers/Api/customerQueryService";

const Contact = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("");
    const [message, setMessage] = useState("");
    const [alertData, setAlertData] = useState(null);
    const [loading, setLoading] = useState(false);

    const validateForm = () => {
        if (!name.trim()) {
            setAlertData({ message: "Please enter your name.", type: "error" });
            return false;
        }
        if (!email.trim()) {
            setAlertData({ message: "Please enter your email address.", type: "error" });
            return false;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email.trim())) {
            setAlertData({ message: "Please enter a valid email address.", type: "error" });
            return false;
        }
        if (!role) {
            setAlertData({ message: "Please select your role.", type: "error" });
            return false;
        }
        if (!message.trim()) {
            setAlertData({ message: "Please write your message.", type: "error" });
            return false;
        }
        return true;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (loading) return;

        if (!validateForm()) {
            return;
        }

        setLoading(true);
        setAlertData(null);

        try {
            const response = await submitCustomerQuery({
                name,
                email,
                role,
                message
            });

            if (response && (response.status === 200 || response.code === 200)) {
                setAlertData({
                    message: response.message || "Your query has been submitted successfully!",
                    type: "success"
                });
                setName("");
                setEmail("");
                setRole("");
                setMessage("");
            } else {
                const errMsg = response?.errors?.msg || response?.message || "Failed to submit query. Please try again.";
                setAlertData({ message: errMsg, type: "error" });
            }
        } catch (error) {
            console.error("Contact Form Error:", error);
            const errMsg =
                error.response?.data?.errors?.msg ||
                error.response?.data?.message ||
                "An error occurred while submitting your query. Please try again.";
            setAlertData({ message: errMsg, type: "error" });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="contact-us text-white mt-5">
            <div className="row">
                {alertData && <Alerts message={alertData.message} type={alertData.type} />}

                <div className="col-md-6 text-md-start contact-text">
                    <h1 className="allFonts">
                        <b>Reach Out & Feature <br /> Request Form !</b>
                    </h1>
                    <p className="allFonts-p">
                        We value your input within our sports ecosystem. Your insights are crucial in helping us improve and enhance your SportsNerve experience.
                    </p>
                    <div className="list">
                        <ul>
                            <li>
                                <h3 className="allFotns">125+</h3>
                                <p className="allFonts-p">Sports types</p>
                            </li>
                            <li>
                                <h3 className="allFotns">100k+</h3>
                                <p className="allFonts-p">teams</p>
                            </li>
                            <li>
                                <h3 className="allFotns">20+</h3>
                                <p className="allFonts-p">Unique Features</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-md-6">
                    <form className="form" onSubmit={handleSubmit}>
                        <div className="row mb-2">
                            <div className="col-md-6 mb-2 mb-md-0">
                                <input
                                    type="text"
                                    placeholder="Name"
                                    value={name}
                                    className="form-control"
                                    onChange={(e) => setName(e.target.value)}
                                    disabled={loading}
                                />
                            </div>
                            <div className="col-md-6">
                                <input
                                    type="email"
                                    placeholder="Email address"
                                    className="form-control"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    disabled={loading}
                                />
                            </div>
                        </div>
                        <select
                            name="Dropdown"
                            id="sportsSelect"
                            className="form-select my-3"
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            disabled={loading}
                        >
                            <option value="">--Select your role--</option>
                            <option value="user">User</option>
                            <option value="facility_manager">Facility Manager</option>
                            <option value="coach">Coach</option>
                        </select>
                        <textarea
                            name="message"
                            id="message"
                            cols="30"
                            rows="8"
                            placeholder="Write your message here..."
                            className="form-control my-4"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            disabled={loading}
                        ></textarea>
                        <div className="text-end submit-btn">
                            <button className="btn btn-danger" type="submit" disabled={loading}>
                                {loading ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;
